import { trackUsage } from '@creditsights/api-ui-web';
import { isArray } from 'lodash';
import { NavigationItem } from '../models/Navigation';

interface TrackOption {
  key: string;
  value: string;
}

export enum NavbarTrackUsageEvents {
  NAVBAR_MENU_ITEM = 'NAVBAR_MENU_ITEM',
  NAVBAR_SUB_MENU_ITEM = 'NAVBAR_SUB_MENU_ITEM',
  SEARCH_PHRASE = 'SEARCH_PHRASE',
  SEARCH_TAG_SUGGESTION = 'SEARCH_TAG_SUGGESTION',
  SEARCH_RESULT_CLICK_ON_SAVED_SEARCH = 'SEARCH_RESULT_CLICK_ON_SAVED_SEARCH',
}

export const trackNavbarMenuItem = (menuName: string): void => {
  trackUsage(NavbarTrackUsageEvents.NAVBAR_MENU_ITEM, [
    {
      key: 'menuItem',
      value: `${menuName}`,
    },
  ]);
};

export const trackNavbarSubMenuItem = (parentMenuName: string, subMenuName: string): void => {
  trackUsage(NavbarTrackUsageEvents.NAVBAR_SUB_MENU_ITEM, [
    {
      key: 'parentMenuItem',
      value: `${parentMenuName}`,
    },
    {
      key: 'subMenuItem',
      value: `${subMenuName}`,
    },
  ]);
};

export const trackSearchPhrase = (phrase: string, type: string): void => {
  trackUsage(NavbarTrackUsageEvents.SEARCH_PHRASE, [
    {
      key: 'searchPhrase',
      value: `${phrase}`,
    },
    {
      key: 'searchType',
      value: `${type}`,
    },
  ]);
};

export const trackTagSuggestion = (tagName: string, tagType: string, phrase: string): void => {
  trackUsage(NavbarTrackUsageEvents.SEARCH_TAG_SUGGESTION, [
    {
      key: 'tagName',
      value: `${tagName}`,
    },
    {
      key: 'tagType',
      value: `${tagType}`,
    },
    {
      key: 'searchPhrase',
      value: `${phrase}`,
    },
  ]);
};

export const trackOnClickSavedSearches = (savedSearch: string): void => {
  trackUsage(NavbarTrackUsageEvents.SEARCH_RESULT_CLICK_ON_SAVED_SEARCH, [
    {
      key: 'savedSearchName',
      value: `${savedSearch}`,
    },
  ]);
};

// flatten nested menu items to get hierarchy of menu item names
const flattenNestedMenu = (
  menuOptions: NavigationItem[],
  parentMenuName: string,
  selectedSubMenuItem: string
): string => {
  let result = '';
  const flatten = (menuOptions: any, menuName: string): void => {
    if (result !== '') {
      return;
    }
    if (isArray(menuOptions)) {
      Object.keys(menuOptions).forEach((option) => {
        flatten(menuOptions[option], `${menuName}`);
      });
    } else if (typeof menuOptions === 'object') {
      if (menuOptions.options) {
        flatten(menuOptions.options, `${menuName}.${menuOptions.text}`);
      } else if (menuOptions.to === selectedSubMenuItem) {
        result = `${menuName}.${menuOptions.text}`;
      }
    }
  };
  flatten(menuOptions, parentMenuName);
  return result;
};

// create track options array of objects for track usage api
const getUsageTrackOption = (nestedMenuNames: string): TrackOption[] => {
  const menuItems = nestedMenuNames.split('.');
  return menuItems.map((menuItem, index) => {
    if (index === menuItems.length - 1) {
      return {
        key: 'subMenuItem',
        value: menuItem,
      };
    }
    return {
      key: `parentMenuItem${index + 1}`,
      value: menuItem,
    };
  });
};

// track navbar menu items when the dropdown menu is nested
export const trackNavbarNestedSubMenuItem = (
  menuOptions: NavigationItem[],
  parentMenuName: string,
  selectedSubMenuItem: string
): void => {
  const nestedMenuNames = flattenNestedMenu(menuOptions, parentMenuName, selectedSubMenuItem);
  trackUsage(NavbarTrackUsageEvents.NAVBAR_SUB_MENU_ITEM, getUsageTrackOption(nestedMenuNames));
};
